<template>
  <div class="page page-contacts">
    <div class="page__wrap">
      <div class="row-1 p-top-3">
        <div data-animate="page-wrap">
          <header data-animate="header-title">
            <h1 data-animate="header-title" class="title-m">
              {{ $t(`pages.contacts.title-${key}`) }}
            </h1>
          </header>
        </div>
        <WidgetNavigationTabs class="m-top-5" :links="navTabContact($t)" />
      </div>
      <div data-animate="page-wrap">
        <div class="p-bot-3" data-animate="page-content">
          <div class="row-1 m-top-6">
            <PagesContactsDistributors :distributors="distributors" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import queries from '@/graphql/craft/queries/index.js'
import { navTabContact } from '@/bucket/navigations.js'

import { useCraftStore } from '@/store/craft.js'
import {
  onBeforeEnter,
  onEnter,
  onLeave,
} from '~/assets/js/page-transitions/contacts.js'

definePageMeta({
  layout: 'default',
  pageTransition: {
    onBeforeEnter: (el) => {
      onBeforeEnter(el)
    },
    onEnter: async (el, done) => {
      const tl = onEnter(el, done)
      await tl.delay(0.5).play()
      done()
    },
    onLeave: async (el, done) => {
      const tl = onLeave(el)
      await tl.play()
      window.lenis.scrollTo(0, { immediate: true })
      done()
    },
  },
})

const { configuration } = useCraftStore()
const { locale } = useI18n()

const route = useRoute()
const italiaKeys = ['italy', 'italia']
const europaKeys = ['europe', 'europa']
const mondoKeys = ['world', 'mondo']

if (
  ![...italiaKeys, ...europaKeys, ...mondoKeys].includes(route.params.region)
) {
  throw createError({ statusCode: 404 })
}

let key = ''
let filter = ''
let localeParams = {}

if (
  locale.value === 'it' &&
  !['italia', 'europa', 'mondo'].includes(route.params.region)
) {
  throw createError({ statusCode: 404 })
}
if (
  ['en', 'en-us'].includes(locale.value) &&
  !['italy', 'europe', 'world'].includes(route.params.region)
) {
  throw createError({ statusCode: 404 })
}

if (italiaKeys.includes(route.params.region)) {
  key = 'distributorsitalia'
  filter = 'italia'
  localeParams = {
    it: { region: 'italia' },
    en: { region: 'italy' },
    'en-us': { region: 'italy' },
  }
}
if (europaKeys.includes(route.params.region)) {
  key = 'distributorseuropa'
  filter = 'europa'
  localeParams = {
    it: { region: 'europa' },
    en: { region: 'europe' },
    'en-us': { region: 'europe' },
  }
}
if (mondoKeys.includes(route.params.region)) {
  key = 'distributorsworld'
  filter = 'mondo'
  localeParams = {
    it: { region: 'mondo' },
    en: { region: 'world' },
    'en-us': { region: 'world' },
  }
}

// Fetch Data
const query = queries.distributors.getDistributors

const variables = computed(() => ({
  site: configuration.site,
}))

const { data } = await useGraphql(query, variables)

const distributors = computed(() =>
  data.value?.distributorsEntries?.[0].distributorsList
    .filter(
      (distributor) =>
        distributor.distributorsRegion.includes(filter) &&
        distributor.distributorsLatitude &&
        distributor.distributorsLongitude
    )
    .map((distributor) => ({
      id: distributor.id,
      name: distributor.distributorsName,
      address: distributor.distributorsAddress,
      meta: distributor.distributorsMeta,
      latitude: distributor.distributorsLatitude,
      longitude: distributor.distributorsLongitude,
    }))
)

const seo = computed(() => {
  return (
    data.value?.contactsEntries?.[0]?.subpageSeo?.find(
      (seo) => seo.subpageSeoMeta === key
    )?.subpageSeoContent || {}
  )
})

// Seo
useSeo({
  ...seo.value,
  localeParams,
})
</script>

<style></style>
